import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import InputAutomationTrainer from './InputAutomationTrainer';
import { loadWirelessTargets, wirelessAuth, wirelessTargetForDevice } from './wirelessDebuggingApi';

export default function WirelessDebuggingTrainer({ siteId, device }) {
  const [targets, setTargets] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [profile, setProfile] = useState(null);
  const [loadedId, setLoadedId] = useState(null);
  const [message, setMessage] = useState('Loading Wireless Debugging targets…');
  const [reload, setReload] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setTargets([]); setSelectedId(''); setLoadedId(null);
    if (siteId) loadWirelessTargets(siteId).then((rows) => {
      if (cancelled) return;
      setTargets(rows);
      setSelectedId(String(wirelessTargetForDevice(rows, device?.id)?.deviceId || rows[0]?.deviceId || ''));
      setMessage(rows.length ? '' : 'Configure a Wireless Debugging target in Pairing before training recovery.');
    }).catch((error) => { if (!cancelled) setMessage(error?.response?.data?.message || 'Could not load Wireless Debugging targets.'); });
    else setMessage('Select a site before training Wireless Debugging recovery.');
    return () => { cancelled = true; };
  }, [siteId, device?.id, reload]);
  const target = targets.find((entry) => String(entry.deviceId) === selectedId);
  const recoveryTarget = useMemo(() => target ? { id: target.deviceId, name: target.name } : null, [target]);
  useEffect(() => {
    let cancelled = false;
    setProfile(null); setLoadedId(null);
    if (target) {
      setMessage('Loading saved recovery routine…');
      axios.get(`/api/site-control/targets/${target.deviceId}/wireless-debugging-routine`, wirelessAuth()).then((response) => {
        if (!cancelled) { setProfile(response.data.profile); setLoadedId(target.deviceId); setMessage(''); }
      }).catch((error) => { if (!cancelled) setMessage(error?.response?.data?.message || 'Could not load the recovery routine.'); });
    }
    return () => { cancelled = true; };
  }, [target]);
  const save = async (candidate) => {
    const response = await axios.put(`/api/site-control/targets/${target.deviceId}/wireless-debugging-routine`, { profile: candidate }, wirelessAuth());
    setProfile(response.data.profile);
    return response.data.profile;
  };
  return <section className="wireless-debugging-training">
    <h3>Wireless Debugging recovery</h3>
    {targets.length > 0 && <label className="wireless-debugging-training__target">Wireless Debugging device{' '}
      <select disabled={busy} value={selectedId} onChange={(event) => setSelectedId(event.target.value)}>
        {targets.map((entry) => <option key={entry.deviceId} value={entry.deviceId}>{entry.name}</option>)}
      </select>
    </label>}
    {message && <p role="status">{message}</p>}
    <button type="button" disabled={busy} onClick={() => setReload((value) => value + 1)}>Refresh recovery targets</button>
    {target && !target.googleRemote?.paired && <p>Pair Android TV Remote in Pairing before sending or testing recovery keys. You can prepare and save a draft now.</p>}
    {target && loadedId === target.deviceId && <InputAutomationTrainer key={target.deviceId}
      recoveryTarget={recoveryTarget} savedRecoveryProfile={profile} onSaveRecovery={save} recoveryTargets={targets} onRecoveryBusyChange={setBusy} />}
  </section>;
}
